import React from 'react';
import { useTranslation } from 'react-i18next';
import { OPINION_TYPES } from '../../hooks/useOpinionTypes';
import './index.scss';

export default function OpinionTypeFilter({ types, onToggle }) {
  const { t } = useTranslation('brand');
  return <div className="opinion-type-filter wiw-control-band" role="group" aria-label={t('opinionTypeFilter')}
    data-neutral-selected={types.includes('neutral')}>
    {OPINION_TYPES.map(({ id, label }) => {
      const selected = types.includes(id);
      return <button key={id} type="button" className={`opinion-type-filter__button opinion-type-filter__button--${id}`}
        data-opinion-type={id} aria-label={t(label)} aria-pressed={selected}
        aria-disabled={selected && types.length === 1 ? 'true' : undefined}
        onClick={() => onToggle(id)}>
        <span className="opinion-type-filter__color" aria-hidden="true" />
      </button>;
    })}
  </div>;
}
